import {
  ensure,
  wrapErrors,
  asAInteger,
  beAtLeast,
  notEmpty,
} from "../Common/composition";

const expressAsKbps = (value) => Math.floor(value * 1000).toString();

export const formatValue = ( precision=0, thousands=true) => value =>
  Number(value).toLocaleString(undefined,  {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
    useGrouping: thousands,
  });

const noDecimalsWithThousands = formatValue(0/*precision*/, /*thousans*/true);

const validateThreshold = wrapErrors(
  (error) => `threshold value ${error}`,
  ensure(notEmpty, asAInteger(beAtLeast(0), expressAsKbps))
);

const thresholdComposition = {
  cliType: "throughput",
  typeLabel: "Throughput",
  viewURL: "viewThroughputProfileConfig",
  profileFn: (row)=>{
    return {
      stored: true, 
      pristine: true,
      name: row["NAME"],
      threshold: row["THRESHOLD-Mbps"]
    }
  },
  fields: [
    { name: "name", label: "Profile name", type: "text", canUpdate: true, resName: "NAME", numeric: false},
    {
      name: "threshold",
      label: "Threshold (Mbps)",
      labelColumn: "THRESHOLD (Mbps)",
      type: "number",
      icon: "label_outline",
      precision: 0,
      renderValue: noDecimalsWithThousands,
      validate: validateThreshold,
      resName: "THRESHOLD-Mbps",
      numeric: true,
    },
  ],
};

export default thresholdComposition;
